import React, {useRef} from 'react'
import IsStep from 'modules/react/loan-calculator/conditionals/IsStep'
import Step1 from 'modules/react/loan-calculator/steps/Step1'
import Step2 from 'modules/react/loan-calculator/steps/Step2'
import Step3 from 'modules/react/loan-calculator/steps/Step3'

export default function Modal () {
  const modalRef = useRef(null)

  const handleCloseModal = () => {
    modalRef.current.classList.remove('mtt-loan-modal--show')
  }

  return (
    <div className='mtt-loan-modal' ref={modalRef}>
      <div className='mtt-loan-modal__inner'>
        <IsStep is={1}>
          <Step1/>
        </IsStep>
        <IsStep is={2}>
          <Step2/>
        </IsStep>
        <IsStep is={3}>
          <Step3 handleCloseModal={handleCloseModal}/>
        </IsStep>
        <div className='popup__close' onClick={handleCloseModal}/>
      </div>
      <div className='mtt-loan-modal__overlay' onClick={handleCloseModal}/>
    </div>
  )
}
